<script>
import Steps from 'element-ui/lib/steps';

export default Steps;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/steps.css';
// Adding RTL support to element's alert

.el-steps {
  display: flex;

  &--horizontal {
    flex-flow: row nowrap;

    @include breakpoint(small) {
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
